// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "form-2hBBb";
var _4 = "wrapper-1rVZV";
var _5 = "header-3eld4";
var _6 = "content-224qA";
var _7 = "description-2DJDi";
var _8 = "passenger-2Rukw";
var _9 = "passenger__label-1v29n";
var _a = "passenger__price-2YlgN";
var _b = "checkbox-2b8fP";
var _c = "checkbox_checked-1jnXb";
var _d = "passenger__checkboxLabel-2Qf8G";
var _e = "total-2ZfNR";
var _f = "passenger__controls-2nTVa";
var _10 = "passenger__dropdown-14WGP";
export { _1 as "__esModule", _2 as "mobile", _3 as "form", _4 as "wrapper", _5 as "header", _6 as "content", _7 as "description", _8 as "passenger", _9 as "passenger__label", _a as "passenger__price", _b as "checkbox", _c as "checkbox_checked", _d as "passenger__checkboxLabel", _e as "total", _f as "passenger__controls", _10 as "passenger__dropdown" }
export default { "__esModule": _1, "mobile": _2, "form": _3, "wrapper": _4, "header": _5, "content": _6, "description": _7, "passenger": _8, "passenger__label": _9, "passenger__price": _a, "checkbox": _b, "checkbox_checked": _c, "passenger__checkboxLabel": _d, "total": _e, "passenger__controls": _f, "passenger__dropdown": _10 }
